"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mobileContainerDimension = exports.Nav = exports.ErrorMessageWrapper = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _sharedStyles = require("./Desktop/sharedStyles");
var _sharedStyle = require("./Mobile/sharedStyle");
const {
  colours
} = _uiKit.theme;
const mobileContainerDimension = exports.mobileContainerDimension = (0, _styledComponents.css)(["max-width:", "px;height:calc(100vh - ", "px);max-height:calc(100vh - ", "px);"], _sharedStyle.navWidth, props => _sharedStyles.headerHeight * 2 + (props.hasHeader ? 62 : 0), props => _sharedStyles.headerHeight * 2 + (props.hasHeader ? 62 : 0));
const Nav = exports.Nav = _styledComponents.default.nav.withConfig({
  displayName: "Navstyle__Nav",
  componentId: "sc-n5kxmd-0"
})(["display:flex;align-items:center;height:", "px;background-color:", ";z-index:100;max-width:100vw;text-shadow:none;border-bottom:solid 4px;border-image:", " 1;a:focus{outline-width:2px;outline-style:solid;outline-color:Highlight;}@media (-webkit-min-device-pixel-ratio:0){a:focus{outline-color:-webkit-focus-ring-color;outline-style:auto;}}"], _sharedStyles.headerHeight, colours.PRIMARY_1, _uiKit.theme.gradients.GRADIENT_3);
const ErrorMessageWrapper = exports.ErrorMessageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Navstyle__ErrorMessageWrapper",
  componentId: "sc-n5kxmd-1"
})(["padding-top:15px;padding-bottom:15px;"]);